import { render, staticRenderFns } from "./crearArticulo.vue?vue&type=template&id=27c80000&"
import script from "./crearArticulo.vue?vue&type=script&lang=js&"
export * from "./crearArticulo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QSeparator,QInput,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSeparator,QInput,QBtn})
